<div fxHide.lt-md class="newrule__header" [class.loading]="creating">
  <h2 fxLayout fxLayoutGap="12px">
    <span>Create magical moments.</span>
    <mat-spinner *ngIf="creating" diameter="32"></mat-spinner>
  </h2>
  <span class="subtitle">
    Save time by automating your conversations. You can create rules to allow {{ 'CORE.PRODUCT_NAME' | transloco }} to
    send messages on your behalf.
  </span>
  <span class="rules__close-btn" (click)="dismissModal()">
    <img src="/assets/iconography/cancel.svg" width="24px" height="24px" />
  </span>
</div>

<div
  class="newrule__body"
  [class.loading]="creating"
  fxLayout
  fxLayout.lt-md="column"
  fxLayoutGap.lt-md="12px"
  [ngClass.lt-md]="{ mobile: true }">
  <div fxFlex>
    <h3>Reply to an event</h3>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('inquiry')">
      <img src="/assets/iconography/gx-create/booking-inquiry.svg" />
      <span data-intercom-target="new-inquiry" class="newrule__option strong" fxFlex>New inquiry</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('preapproved')">
      <img src="/assets/iconography/gx-create/booking-request.svg" />
      <span data-intercom-target="new-pre-approval" class="newrule__option strong" fxFlex>New pre-approval</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('pending')">
      <img src="/assets/iconography/gx-create/booking-alteration.svg" />
      <span data-intercom-target="new-request-to-book" class="newrule__option strong" fxFlex>New request to book</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('accepted')">
      <img src="/assets/iconography/gx-create/booking-alteration.svg" />
      <span data-intercom-target="new-reservation" class="newrule__option strong" fxFlex>New reservation</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('cancelled')">
      <img src="/assets/iconography/gx-create/booking-cancelled.svg" />
      <span data-intercom-target="new-cancellation" class="newrule__option strong" fxFlex>New cancellation</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('timedout')">
      <img src="/assets/iconography/gx-create/booking-cancelled.svg" />
      <span data-intercom-target="expired-pre-approval" class="newrule__option strong" fxFlex>
        Expired pre-approval
      </span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('denied')">
      <img src="/assets/iconography/gx-create/booking-cancelled.svg" />
      <span data-intercom-target="inquiry-booking-denied" class="newrule__option strong" fxFlex>
        Inquiry/booking denied
      </span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('special_offer')">
      <img src="/assets/iconography/gx-create/booking-inquiry.svg" />
      <span data-intercom-target="new-special-offer" class="newrule__option strong" fxFlex>New special offer</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('awaiting_payment')">
      <img src="/assets/iconography/gx-create/booking-cancelled.svg" />
      <span data-intercom-target="new-payment-issue" class="newrule__option strong" fxFlex>New payment issue</span>
    </div>
  </div>

  <div fxFlex>
    <h3>Schedule a message</h3>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('scheduled:accepted')">
      <img src="/assets/iconography/gx-create/booking-alteration.svg" />
      <span data-intercom-target="after-booking" class="newrule__option strong" fxFlex>After a new reservation</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('checkin', true)">
      <img src="/assets/iconography/gx-create/check-in.svg" />
      <span data-intercom-target="before-check-in" class="newrule__option strong" fxFlex>Before check-in</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('checkin')">
      <img src="/assets/iconography/gx-create/check-in.svg" />
      <span data-intercom-target="after-check-in" class="newrule__option strong" fxFlex>After check-in</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('checkout', true)">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span data-intercom-target="before-check-out" class="newrule__option strong" fxFlex>Before check-out</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('checkout')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span data-intercom-target="after-check-out" class="newrule__option strong" fxFlex>After check-out</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('recurring:weekly')">
      <img src="/assets/iconography/gx-create/check-out.svg" />
      <span data-intercom-target="on-a-given-day-of-the-week" class="newrule__option strong" fxFlex>
        On a given day of the week
      </span>
    </div>
  </div>

  <div fxFlex>
    <h3>Reply to a question about...</h3>
    <mat-spinner *ngIf="loadingIntents" [diameter]="16"></mat-spinner>
    <ng-container *ngFor="let intent of intents; let i = index">
      <div
        *ngIf="i < 4"
        fxLayout
        class="newrule__option-container"
        fxLayoutGap="12px"
        (click)="createQuestionRule(intent)">
        <img src="/assets/iconography/gx-create/question.svg" />
        <span class="newrule__option strong" fxFlex>{{ intent.name }}</span>
      </div>
    </ng-container>
    <button
      *ngIf="intents && intents.length > 4"
      type="submit"
      mat-flat-button
      class="button__text"
      [matMenuTriggerFor]="intentsMenu">
      More questions
    </button>
    <mat-menu #intentsMenu="matMenu">
      <button
        mat-menu-item
        [attr.data-intercom-target]="intent.name + '-question'"
        *ngFor="let intent of intents; let i = index"
        (click)="createQuestionRule(intent)">
        {{ intent.name }}
      </button>
    </mat-menu>
  </div>

  <div fxFlex>
    <h3>More</h3>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('review')">
      <img src="/assets/iconography/gx-create/review.svg" />
      <span data-intercom-target="add-review" class="newrule__option strong" fxFlex>Add a review template</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('static:canned')">
      <img src="/assets/iconography/gx-create/canned-response.svg" />
      <span data-intercom-target="canned-response" class="newrule__option strong" fxFlex>Create a canned response</span>
    </div>
    <div fxLayout class="newrule__option-container" fxLayoutGap="12px" (click)="createRule('checkpoint')">
      <img src="/assets/iconography/gx-create/booking-inquiry.svg" />
      <span data-intercom-target="new-checkpoint-message" class="newrule__option strong" fxFlex>
        New checkpoint message
      </span>
    </div>
  </div>
</div>
